import clsx from "clsx";
import styles from "./styles.module.scss";
import { useState } from "react";
import WheelDateTimePicker, { type DateTimeValue } from "../wheel-datetime-picker";

export default function MobilePicker({
  className,
  error,
  onChange,
  value,
  start = new Date().getFullYear(),
  length = 1,
  calc = "ADD",
  includeTime = false,
  ...props
}: {
  className?: string;
  error?: boolean;
  onChange: (...event: unknown[]) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: any;
  start?: number;
  length?: number;
  calc?: "ADD" | "SUB";
  includeTime?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handlePickerChange = (newValue: DateTimeValue) => {
    onChange(newValue);
  };

  return (
    <>
      <button
        className={clsx(styles.button, error && styles.destructive, className)}
        type="button"
        onClick={() => setIsOpen(true)}
        children={
          includeTime
            ? `${value.year}年 ${value.month}月 ${value.day}日 ${value.hour || "00"}:${value.minute || "00"}`
            : `${value.year}年 ${value.month}月 ${value.day}日`
        }
        {...props}
      />
      <WheelDateTimePicker
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onChange={handlePickerChange}
        value={value}
        mode={includeTime ? 'datetime' : 'date'}
        start={start}
        length={length}
        calc={calc}
      />
    </>
  );
}
